import http from 'hub-http/clients/apiClient';
const API_BASE = 'userpreferences/v1/notifications';
export default class NotificationsAPI {
  static getNotifications() {
    return http.get(API_BASE);
  }
  static toggleEmailSubscription({
    notificationType,
    subscribed
  }) {
    if (subscribed) {
      return NotificationsAPI.subscribeToEmail(notificationType);
    }
    return NotificationsAPI.unsubscribeFromEmail(notificationType);
  }
  static subscribeToEmail(notificationType) {
    return http.post(`${API_BASE}/${notificationType}/subscribe`);
  }
  static unsubscribeFromEmail(notificationType) {
    return http.post(`${API_BASE}/${notificationType}/unsubscribe`);
  }
  static setLeadRevisitSetting({
    leadRevisitType
  }) {
    return http.post(`${API_BASE}/lead-revisit-setting/${leadRevisitType}`);
  }
  static resendEmail({
    notificationType
  }) {
    return http.post(`${API_BASE}/${notificationType}/resend`);
  }
  static sendEmail({
    notificationType,
    emailAddresses
  }) {
    return http.post(`${API_BASE}/${notificationType}/send`, {
      data: {
        emailAddresses
      }
    });
  }
}